import React from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorMessage } from '@incentivegames/ig-component-common/lib/index';
import { IGame, IGameEntry, ITeamMember } from '@incentivegames/ig-types/lib/interfaces/apiContracts';

import { ICardContextProvider } from 'context/cardContext';
import Card from 'components/Card';
import CardStubbedDataWrapper, { MODES } from 'components/Card/components/CardStubbedDataWrapper';
import GameCardContainer from 'components/GameCardContainer';

import './FivesView.scss';

export interface IFivesViewData {
  entry?: IGameEntry;
  game?: IGame;
  error?: string;
}
export interface IFivesViewProps {
  data: IFivesViewData;
}

const FivesView = (props: IFivesViewProps) => {
  const { t } = useTranslation();

  const getViewIfEntry = () => {
    return props.data.entry!.team.map((teamMember: ITeamMember, index: number) => {
      const data: ICardContextProvider = {
        player: teamMember,
        receipt: props.data.entry!.receipt,
        gameId: props.data.game!.gameId,
        noEntry: false,
        zIndex: props.data.entry!.team.length - index
      };
      return <Card key={index} {...data} />;
    });
  };

  const getViewIfNoEntry = () => {
    const cards = [];
    for (let index = 0; index < 5; index++) cards.push(<CardStubbedDataWrapper mode={MODES.PLACEHOLDER} index={index} key={index} />);
    return cards;
  };

  if (props.data.error) {
    return <ErrorMessage wrapperBackgroundColor="white" wrapperMargin="5px" messagePadding="10px" messageTextAlign="center" errorTextColor="black" error={t('error-message')} />;
  } else {
    return (
      <div className="fives">
        <GameCardContainer>{props.data.entry ? getViewIfEntry() : getViewIfNoEntry()}</GameCardContainer>
      </div>
    );
  }
};

export default FivesView;
